export default {"src":"/_next/static/media/ChooseIocn2.59f0c311.svg","height":56,"width":51};